import React , { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import Locations from "./components/Locations";
import Commercial from "./components/Commercial";
import CompanyWithDeal from "./components/CompanyWithDeal";
import Footer from "./components/Footer";
import AOS from 'aos';
import "aos/dist/aos.css"

export const languages= [
  {
    code : 'en',
    name : 'English',
    country_code : 'gb'
  },
  {
    code : 'ar',
    name : 'العربية',
    country_code : 'sa',
    dir : 'rtl',
  }
]

function App() {
  const { t } = useTranslation();
  useEffect( () => {
    AOS.init();
  })
  
  return (
    <div>
      <Navbar />
      <Header />
      <Commercial />
      <CompanyWithDeal />
    <Locations />
    <Footer />
    </div>
  );
}

export default App;
